import { useChainId, useSwitchChain } from "wagmi";
import { byId } from "@/lib/chains";

/**
 * Compares the wallet's current chain against a target chain id (the
 * chain where an on-chain action needs to run — e.g. the chain a
 * collection lives on, or the chain a fresh deploy is targeting).
 * Returns enough state for an action button to disable itself and tell
 * the user what to do.
 *
 * Without this guard a creator on Mordor who clicks "Pause" on an ETC
 * collection just gets a wallet popup that fails — and our ChainSwitcher
 * dropdown only handles the home/dashboard filter, not per-row actions.
 */
export function useChainMismatch(targetChainId: number) {
  const walletChainId = useChainId();
  const { switchChain, isPending: isSwitching } = useSwitchChain();
  const target = byId(targetChainId);

  const wrong = !!walletChainId && walletChainId !== targetChainId;

  return {
    wrong,
    isSwitching,
    targetName: target?.name ?? `chain ${targetChainId}`,
    walletChainId,
    /** Suitable for `<button title={...}>` — empty string when no problem. */
    tooltip: wrong ? `Switch wallet to ${target?.name ?? targetChainId} to continue` : "",
    switchToTarget: () => {
      if (wrong) switchChain({ chainId: targetChainId });
    },
  };
}
